<template>
 <div class="range-picker">
  
    <v-text-field 
            v-model="dateRangeText"
            label="Enter date range"
            prepend-icon="mdi-calendar"
            readonly
           
          ></v-text-field>
   <!-- <v-spacer></v-spacer> -->
   <v-btn color="primary" dark @click.stop="dialog = true"><v-icon>mdi-reload</v-icon> Change dates</v-btn>



   <v-dialog v-model="dialog">
    <v-date-picker
            v-model="range"
            range
            :first-day-of-week="4"
            picker-date
          ></v-date-picker>
   </v-dialog>
 </div>
</template>

<script>
import { mapState } from 'vuex'
  export default {

    data() {
            return {
              range : this.getDefaultWeek(),
              dialog : false
             
            }
        },

    mounted ()  {

     //this.range = this.getDefaultWeek()

    },

    computed: {

      dateRangeText () {
        return this.range.join(' ~ ') 
        }
      },


      watch: {

          range (val) {

            
            if (val.length == 2) { //if the two dates have been selected

            
                this.$emit('reloadData', val)
              //this.reloadData(val)


              this.dialog = false

            }
          }
            
        },


        methods : {

            loadData(range) { this.$emit('reloadData', range) }
        }
        
     
    
    
  }
</script>